import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDataContext } from "../Context/dataContext";
import { toast, ToastContainer } from "react-toastify";
import { FaLock } from "react-icons/fa";

function RecoverUpdate() {
  const navigate = useNavigate();
  const { url } = useDataContext();
  const { id, email } = useParams();
  const [userEmail, setUserEmail] = useState({});
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("La contraseña debe contener al menos 8 caracteres.");
      return;
    }
    if (confirmPassword !== password) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }
    if (email !== userEmail.use_email || parseInt(id) !== userEmail.use_id) {
      toast.error("Los datos no coinciden.");
      return;
    }

    try {
      await axios.put(`${url}/Admin/password/${id}`, {
        use_password: password,
      });
      toast.success("¡Contraseña actualizada con éxito!");
      setTimeout(() => navigate("/Login"), 2000);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Ocurrió un error. Por favor, intenta de nuevo.");
    }
  };

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(`${url}/Admin/email/${email}`);
      setUserEmail(response.data);
    } catch (error) {
      console.error(error);
    }
  }, [email, url]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="login-wrapper">
      <div className="login-container">
        <h2>Actualizar Contraseña</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="password">Nueva Contraseña</label>
            <div className="input-container">
              <FaLock className="input-icon" />
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Ingresa tu nueva contraseña"
              />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="confirm-password">Confirmar Contraseña</label>
            <div className="input-container">
              <FaLock className="input-icon" />
              <input
                type="password"
                id="confirm-password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Confirma tu nueva contraseña"
              />
            </div>
          </div>
          <button type="submit">Actualizar Contraseña</button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
}

export { RecoverUpdate };
  